import { EHR_CURRENT_CHANNEL_SORT_BY_FILTER, useStorage } from '@/libs/storage'

import { mapDocs } from './utils'

// filter and sort
const setCurrentPage = (state, currentPage) => {
  Object.assign(state, { currentPage })
}

const increaseCurrentPage = state => ++state.currentPage

const setCurrentFilters = (state, filters) => {
  const currentFilters = { ...state.currentFilters, ...filters }
  Object.assign(state, { currentFilters })
}

const setCurrentSortBy = (state, currentSortBy) => {
  Object.assign(state, { currentSortBy })
  const { setItem } = useStorage(EHR_CURRENT_CHANNEL_SORT_BY_FILTER)
  setItem(currentSortBy.type)
}

// chats tab
const setNewChats = (state, docs) => {
  const newChats = mapDocs(docs)
  Object.assign(state, { newChats })
}

const setOngoingChats = (state, docs) => {
  const ongoingChats = mapDocs(docs)
  Object.assign(state, { ongoingChats })
}

// channels tab
const setActiveChannels = (state, docs) => {
  const activeChannels = mapDocs(docs)
  Object.assign(state, { activeChannels })
}

const setFollowUpChannels = (state, docs) => {
  const followUpChannels = mapDocs(docs)
  Object.assign(state, { followUpChannels })
}

const setMentionChannels = (state, docs) => {
  const mentionChannels = mapDocs(docs)
  Object.assign(state, { mentionChannels })
}

const setArchivedChannels = (state, docs) => {
  const archivedChannels = mapDocs(docs)
  Object.assign(state, { archivedChannels })
}

const setNewChatsListener = (state, listener) => {
  if (state.newChatsListener) {
    state.newChatsListener()
  }
  state.newChatsListener = listener
}

const clearNewChatsListener = state => {
  if (state.newChatsListener) {
    state.newChatsListener()
  }
  state.newChatsListener = null
}

export default {
  setCurrentFilters,
  setCurrentSortBy,
  setCurrentPage,
  increaseCurrentPage,
  setNewChats,
  setOngoingChats,
  setActiveChannels,
  setFollowUpChannels,
  setMentionChannels,
  setArchivedChannels,
  setNewChatsListener,
  clearNewChatsListener
}
